import { render, staticRenderFns } from "./MembraneModal.vue?vue&type=template&id=16fc3c87&"
import script from "./MembraneModal.vue?vue&type=script&lang=js&"
export * from "./MembraneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports